import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import ahrq from "../../img/ahrq.png"
import asha from "../../img/asha.png"
import ids from "../../img/ids.png"
import caqh from "../../img/caqh.png"
import globalUseStyles from '../../styleHooks';


function HomeClients() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={globalClasses.containerBottomPadding} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
          <Grid item xs={12} md={12} container alignItems="center">
            <Grid item xs={12}>
              <Typography align="center" variant="h2">Our Clients</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography align="center" variant="body1">Some of the clients we've loved working with.</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} align="center">
              <img className={globalClasses.clientImg} src={ahrq} alt="ahrq"/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}  align="center">
              <img className={globalClasses.clientImg} src={caqh} alt="caqh"/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}  align="center">
              <img className={globalClasses.clientImg} src={ids} alt="ids"/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}  align="center">
              <img className={globalClasses.clientImg} src={asha} alt="asha"/>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default HomeClients;